// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-container-banner {
    position: relative;
    width: 100%;
    max-width: 480px; /* biar nggak terlalu besar di layar kecil */
    aspect-ratio: 16 / 10;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    background: #f8f9fa;
}

.preview-image-banner {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.badge-app {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    color: white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}
.badge-app i {
    margin-right: 4px;
    font-size: 11px;
}

.badge-app:hover {
    transform: scale(1.05);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/component/banner/banner.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB,EAAE,4CAA4C;IAC9D,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;AAC7C;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,yCAAyC;AAC7C","sourcesContent":[".preview-container-banner {\n    position: relative;\n    width: 100%;\n    max-width: 480px; /* biar nggak terlalu besar di layar kecil */\n    aspect-ratio: 16 / 10;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #f8f9fa;\n}\n\n.preview-image-banner {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.badge-app {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n    color: white;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n}\n.badge-app i {\n    margin-right: 4px;\n    font-size: 11px;\n}\n\n.badge-app:hover {\n    transform: scale(1.05);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
